import { type ChangeEventHandler, useEffect, useState } from 'react';
import '../../../../css/text-editor.less';
import translations from '../../translations';

type TextEditorProps = {
    text: string;
    labelledBy: string;
    autofocus?: boolean;
    onChange: ChangeEventHandler<HTMLInputElement>;
};

const TextEditor = ({ text, labelledBy, autofocus, onChange }: TextEditorProps) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
        onChange(event);
    };

    const enableEditing = () => {
        setIsEditing(true);
    };

    const disableEditing = () => {
        setIsEditing(false);
    };

    useEffect(() => {
        if (autofocus) {
            setIsEditing(true);
        }
    }, [autofocus]);

    return (
        // biome-ignore lint/a11y/useSemanticElements: Requires dedicated refactor to use correct element
        <div
            className="text-editor flex"
            onKeyDown={enableEditing}
            onFocus={enableEditing}
            onClick={enableEditing}
            role="button"
            tabIndex={0}
            data-testid="text-editor"
        >
            {isEditing ? (
                <input
                    className="flex-grow text-padding text-editor-input"
                    autoFocus
                    value={text}
                    onChange={handleChange}
                    onBlur={disableEditing}
                    data-testid="text-editor-input"
                    aria-labelledby={labelledBy}
                />
            ) : (
                <span className="flex-grow text-padding text-editor-display">{text}</span>
            )}
            {isEditing ? null : (
                <button
                    className="btn-icon flex-child-right"
                    data-testid="text-editor-button"
                    onClick={enableEditing}
                    type="button"
                    aria-label={translations.COMMON_edit}
                >
                    <span className="glyphicon glyphicon-pencil" />
                </button>
            )}
        </div>
    );
};

export default TextEditor;
